export function slugify(str) {
  return String(str)
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
}

export function getIdFromSlug(slugStr) {
  // Split the slug using hyphen as the delimiter
  const parts = slugStr.split('-');

  // The ID should be the last part of the slug
  const id = parts[parts.length - 1];

  // Return the extracted ID
  return id;

}


export function getBattingAvg(data, playerData) {
  var avg = 0;

  if (data?.P != 0) {
      if ((parseInt(data?.P) - parseInt(data?.NO) - parseInt(data?.DNB)) == 0)
          avg = parseFloat(data?.R).toFixed(2);
      else
          avg = parseFloat(data?.R / (parseInt(playerData?.P) - parseInt(data?.NO) - parseInt(data?.DNB))).toFixed(2);
  }
  return avg;
}
export function getBattingSR(data) {
  var srRate = 0;
  if (data?.B != 0) {
      srRate = parseFloat(data?.R / data?.B * 100).toFixed(2);
  }
  return srRate;
}
export function getBowlingEconomy(data) {
  var econ = 0;
  if (data?.Overs != 0)
      econ = (data?.Runs / data?.Overs).toFixed(2);
  return econ;
}
export function getBowlingAvg(data) {
  var avg = 0;
  if (data?.Wickets != 0)
      avg = (data?.Runs / data?.Wickets).toFixed(2);
  return avg;
}